import { render, staticRenderFns } from "./TabsView.vue?vue&type=template&id=3ec00048&"
import script from "./TabsView.vue?vue&type=script&lang=js&"
export * from "./TabsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports